import React from "react";
import { Spin } from "antd";

const FormContentLoader = ({
  loading,
  tip = "Loading...",
  minHeight = 320,
  children,
}) => {
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight,
          width: "100%",
          padding: "48px 16px",
        }}
      >
        <Spin size="large" tip={tip} />
      </div>
    );
  }

  return children;
};

export default FormContentLoader;
